// src/context/UploadContext.jsx
import React, { createContext, useState, useContext } from 'react';

const UploadContext = createContext();

export const useUpload = () => useContext(UploadContext);

export const UploadProvider = ({ children }) => {
  const [uploads, setUploads] = useState([]);

  const addUpload = (fileName) => {
    setUploads((prev) => [...prev, { name: fileName, status: 'uploading' }]);
  };

  const markComplete = (fileName) => {
    setUploads((prev) =>
      prev.map((f) =>
        f.name === fileName ? { ...f, status: 'done' } : f
      )
    );
  };

  const clearUploads = () => setUploads([]);

  return (
    <UploadContext.Provider value={{ uploads, addUpload, markComplete, clearUploads }}>
      {children}
    </UploadContext.Provider>
  );
};
